export class WorkloadTimeOffApprovalDelegationEntity {
  public id!: string;
  public teamId!: string;
  public teamName!: string;
  public delegatedUserId!: string | null;
  public delegatedName!: string | null;
}

export class WorkloadTimeOffBlockEntity {
  public id!: string;
  public timeOffTypeId!: string;
  public timeOffTypeName!: string;
  public startDate!: string;
  public endDate!: string;
  public notes!: string | null;
  public approvalDelegations!: WorkloadTimeOffApprovalDelegationEntity[];
}
